'use strict'

import * as BasUtil from '@basalte/bas-util'

angular
  .module('basalteApp')
  .controller('tidalLibraryCtrl', [
    '$scope',
    '$uiRouterGlobals',
    'BAS_APP_PROFILE',
    'BasLibraryHeader',
    'BasLibraryPage',
    'BasLibraryDetail',
    'TidalManager',
    'BasCurrentAppProfile',
    'LibraryState',
    tidalLibraryCtrl
  ])

/**
 * @param $scope
 * @param $uiRouterGlobals
 * @param {BAS_APP_PROFILE} BAS_APP_PROFILE
 * @param BasLibraryHeader
 * @param BasLibraryPage
 * @param BasLibraryDetail
 * @param TidalManager
 * @param {BasCurrentAppProfile} BasCurrentAppProfile
 * @param {LibraryState} LibraryState
 */
function tidalLibraryCtrl (
  $scope,
  $uiRouterGlobals,
  BAS_APP_PROFILE,
  BasLibraryHeader,
  BasLibraryPage,
  BasLibraryDetail,
  TidalManager,
  BasCurrentAppProfile,
  LibraryState
) {
  var root = this

  /**
   * @type {?PlayerLibraryState}
   */
  var libraryState = LibraryState.getCurrentState()

  root.BasLibraryPage = BasLibraryPage
  root.BasLibraryHeader = BasLibraryHeader
  root.BasLibraryDetail = BasLibraryDetail
  root.historyType = BAS_APP_PROFILE.K_TIDAL

  /**
   * @type {BasCurrentAppProfileState}
   */
  root.profileSettings = BasCurrentAppProfile.get()

  /**
   * @type {TidalManager}
   */
  root.manager = libraryState.tidalManager

  init()

  function init () {

    var basSource

    $scope.$on('$destroy', onDestroy)

    if (!BasUtil.isObject(root.manager)) {

      root.manager = new TidalManager(libraryState)
      libraryState.tidalManager = root.manager
    }

    // Initialize service
    root.manager.resume()

    if (
      $uiRouterGlobals.params.id &&
      $uiRouterGlobals.params.type
    ) {
      basSource = LibraryState.getTidalSource()

      if (basSource) {

        basSource.tidal.getSongInfo($uiRouterGlobals.params.id)
          .then(onSongInfo)
      }

      $uiRouterGlobals.params.id = ''
    }
  }

  function onSongInfo (result) {

    root.manager.selectElement(result, $uiRouterGlobals.params.type)

    $uiRouterGlobals.params.type = ''
  }

  function onDestroy () {

    root.manager.suspend()
  }
}
